import styled from 'styled-components'
import * as All from '../BaseStyles'

export const AppTypeItemDiv = styled(All.Div)`
    box-shadow:
    0 0px 0.3px rgba(0, 0, 0, 0.07),
    0 0px 0.9px rgba(0, 0, 0, 0.044),
    0 0px 4px rgba(0, 0, 0, 0.028)
    ;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 1.4rem 0.2rem;
    padding: 10rem 0rem;
    background: white;
    border-radius: 0.8rem;
    &:hover {
        background: #E8E8E8;
    }
`

export const ItemSectionDiv = styled(All.Div)`
    width: 100%;
    height: 100%;
    text-align: center; 
    font-size: 1.7rem;
    font-weight: 550;
`

export const AppTypeNameDiv = styled(All.Div)`
    margin: 1.25rem 0rem;
    padding: 0rem 1rem;
    overflow-wrap: break-word;
`
